import { Link } from "react-router-dom";
import { Checkbox } from "./ui/checkbox";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { AlertTriangle } from "lucide-react";
import { MIN_OVERRIDE_REASON, describeMatch } from "../lib/collaborators";

// Refus de doublon renvoyé par le serveur : ne montre que ce que le serveur a choisi de montrer (jamais de fiche hors portée) et
// ne propose la confirmation que si le serveur dit qu'elle est possible pour cet utilisateur.
export default function DuplicateNotice({ refusal, confirmed, reason, onConfirmedChange, onReasonChange }) {
  if (!refusal) return null;
  const matches = refusal.matches || [];
  const blocking = refusal.code === "duplicate_blocking";
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/70 p-4 space-y-3 text-sm" role="alert" data-testid="duplicate-notice">
      <div className="flex items-start gap-3">
        <AlertTriangle size={18} className="text-amber-600 shrink-0 mt-0.5" />
        <div className="space-y-1.5">
          <div className="font-medium text-slate-900" data-testid="duplicate-notice-message">{refusal.msg}</div>
          {matches.length > 0 && (
            <ul className="space-y-1">
              {matches.map((m) => (
                <li key={m.id}>
                  <Link to={`/collaborateurs/${m.id}`} className="text-jamora hover:underline" data-testid={`duplicate-match-${m.id}`}>
                    {describeMatch(m)}
                  </Link>
                  {m.archived && <span className="text-xs text-slate-500"> (archivée)</span>}
                </li>
              ))}
            </ul>
          )}
          {refusal.others_hidden && <p className="text-xs text-slate-600">D'autres fiches hors de votre périmètre correspondent aussi.</p>}
          {blocking && !refusal.can_override && <p className="text-xs text-slate-600">Seul un administrateur peut enregistrer cette personne malgré tout.</p>}
        </div>
      </div>
      {refusal.can_override && (
        <div className="space-y-2 pl-0 md:pl-8">
          <div className="flex items-start gap-2.5">
            <Checkbox id="confirm-duplicates" checked={confirmed} onCheckedChange={(v) => onConfirmedChange(v === true)} data-testid="confirm-duplicates" className="mt-0.5" />
            <Label htmlFor="confirm-duplicates" className="font-normal leading-snug">
              Je confirme que ce n'est pas un doublon à corriger (contact partagé, homonyme…).
            </Label>
          </div>
          {confirmed && (
            <div className="space-y-1">
              <Label htmlFor="override-reason" className="text-xs text-slate-600">Motif (au moins {MIN_OVERRIDE_REASON} caractères)</Label>
              <Textarea id="override-reason" value={reason} onChange={(e) => onReasonChange(e.target.value)} rows={2} className="text-base md:text-sm" data-testid="override-reason" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
